module.exports = __webpack_public_path__ + "img/information-fill.ad31e221.svg";